import { Stack, useRouter } from 'expo-router';
import { CustomTextStyles } from '@/components/CustomText';
import { HeaderBackButton } from "expo-router/react-navigation";
import { AppText } from '@/components/AppText';
import { HeaderLeft } from '@/components/HeaderLeft';
import { WidthResponsiveText } from '@/components/WidthResponsiveText';

export default function StackedProfile() {
  const router = useRouter();
  
  return (
    <Stack
      screenOptions={({ navigation }) => ({
        headerTitleStyle: CustomTextStyles.headerTitle,

        // Remove horizontal bottom line for header
        headerShadowVisible: false,

        headerStyle: {
          backgroundColor: 'transparent',
        },
        
        headerBackTitle: '',

        headerBackButtonDisplayMode: 'minimal',
                
        headerTitle: ({ children }) => (
          <WidthResponsiveText leftPadding={50} rightPadding={50} style={CustomTextStyles.headerTitle}>
            {children}
          </WidthResponsiveText>
        ),

        headerLeft: () => <HeaderLeft />,
      })}
    >
      <Stack.Screen name="[manage_collab_id]" options={{ title: 'Manage Collab', headerShown: false }} />
    </Stack>
  );
}
